import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { initializeApp } from 'firebase/app';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppComponent } from './app/app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { AUTH_PATHS } from 'src/app/calvin-emr-shared/state/auth/auth.store';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';
import { PATH_LOGIN } from 'src/app/login/login.global';
import { isKnightmedsCabinetMode } from './environments/deploy_info';
import { PATH_RELEASE_PAGES } from 'src/app/global';

if (environment.production) {
  enableProdMode();
}

initializeApp(environment.firebaseConfig);

// see https://primeng.org/theming
const calvinEmrPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}',
        },
      },
    },
  },
  components: {
    menubar: {
      colorScheme: {
        light: {
          root: {
            background: '{blue.100}',
          },
        },
        dark: {
          root: {
            background: '{blue.900}',
          },
        },
      },
    },
  },
});

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    ),
    MessageService,
    { provide: AUTH_PATHS, useValue: { onLogin: isKnightmedsCabinetMode() ? PATH_RELEASE_PAGES : PATH_PATIENTS, onLogout: PATH_LOGIN } },
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: calvinEmrPreset,
      },
    }),
  ],
}).catch((err) => console.error(err));
